import {Alert, Snackbar} from "@mui/material";
import {useNotificationStore} from "../stores/notificationStore";

const NotificationsComponent = () => {
    const notificationStore = useNotificationStore();

    const onClose = notificationStore.closeNotification;

    return (
        <Snackbar open={notificationStore.open} autoHideDuration={6000} onClose={onClose}
                  anchorOrigin={{vertical: "top", horizontal: "center"}}>
            <Alert onClose={onClose} severity={notificationStore.severity} sx={{width: '100%'}}>
                {notificationStore.message}
            </Alert>
        </Snackbar>
    )
}

export default NotificationsComponent;